export default {"src":"/_next/static/media/visa-grey.1e4d3c3f.svg","height":14,"width":40,"blurWidth":0,"blurHeight":0};